import { render, staticRenderFns } from "./sundyStatus.vue?vue&type=template&id=2a67f603&"
import script from "./sundyStatus.vue?vue&type=script&lang=js&"
export * from "./sundyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports